import { Component, EventEmitter, Output } from '@angular/core';
import { InputComponent } from '@app/modules/change-requests/interfaces/input-component.class';

@Component({
    selector: 'rate-input-component',
    template: `
        <div>
            <mat-form-field class="no-labels no-helpers">
                <input
                    matInput
                    type="text"
                    placeholder="Compensation Rate"
                    [disabled]="disabled"
                    [attr.aria-label]="ariaLabel"
                    [(ngModel)]="value"
                    (input)="valueUpdated.emit(value)"
                    [errorStateMatcher]="errorStateMatcher"
                />
                <mat-error>{{ errorMessage }}</mat-error>
            </mat-form-field>
        </div>
    `,
})
export class RateInputComponent extends InputComponent {
    @Output() valueUpdated: EventEmitter<string> = new EventEmitter<string>();
    value = '';
}
